import IDeal, { DealStatus, IDealsPayload, IPrimaryIssuer } from '@/finsight/domain/vo/IDeal';

export const dealStatusName = {
  [DealStatus.Pulled]: 'Pulled',
  [DealStatus.InMarket]: 'In Market',
  [DealStatus.Priced]: 'Priced',
};

export const initialDealsState = {
  collection: [],
  isCollectionFetching: true,
  isFetchingMoreDeals: false,
  bufferCollection: [],
  totalCount: 0,
  page: 1,
  perPage: 10,
  pageTitle: '',
  subscriptions: {
    isFetching: false,
    isSubscribed: false,
    isSubscribeModalVisible: false,
    subscriptionId: '',
  },
};

export interface IDealByIdState {
  totalCount: number,
  collection: IDeal[],
  hasServerError?: boolean,
  pageFilters?: IDealsPayload,
}

export const initialDealByIdState: IDealByIdState = {
  totalCount: 0,
  collection: [],
  hasServerError: false,
  pageFilters: {
    page: 1,
    filters: {
      hasEitherPricingOrAnnouncedDate: false,
      includedDealViewIds: [],
    },
    filterType: 'deal',
  },
};

export interface ICompanyByIdState {
  viewId: number | null,
  id: string | null,
  name?: string,
  industryId?: string,
  subindustryId?: string,
  publicExchange?: any,
  publicTicker?: string,
  abbreviation?: string,
  issuerTicker?: string,
  hasServerError: boolean,
}

export const initialCompanyByIdState: ICompanyByIdState = {
  viewId: null,
  id: null,
  name: null,
  hasServerError: false,
};

export interface IDealsSubscriptionState {
  totalCount: number,
  collection: IDeal[],
  hasServerError?: boolean,
  subscriptionStatus: ISubscriptionStatus,
  pageFilters?: IDealsPayload,
}

export interface ISubscriptionStatus {
  subscriptionId: string,
  subscriptionSubgroupName: string,
  subscriptionName: string,
  isSubscribed: boolean,
}

export const initialDealsSubscriptionState: IDealsSubscriptionState = {
  totalCount: 0,
  collection: [],
  hasServerError: false,
  subscriptionStatus: {
    subscriptionId: '',
    subscriptionSubgroupName: '',
    subscriptionName: '',
    isSubscribed: false,
  },
  pageFilters: {
    page: 1,
    perPage: 10,
    filters: {
      hasEitherPricingOrAnnouncedDate: false,
      includedDealViewIds: [],
      includedStatusGroups: [],
    },
    filterType: '',
  },
};

export const formatDealName = (deal: Partial<IDeal> = {}): string => {
  if (!Object.keys(deal).length) {
    return '';
  }

  const issuer: Partial<IPrimaryIssuer> = deal.primaryIssuer || {};
  const parts = [(issuer.name || '')];

  if (issuer.issuerTicker) {
    parts.push(`(${ issuer.issuerTicker })`);
  }

  parts.push(deal.seriesName || '');
  return parts.join(' ');
};

export const getDealStatusFilterItems = (selectedDealStatuses: DealStatus[]) => (
  Object.values(DealStatus).map((status) => ({
    abbreviation: dealStatusName[status],
    id: status,
    isActive: selectedDealStatuses.includes(status),
    name: dealStatusName[status],
  }))
);

export const getFiltersDealStatus = (dealStatuses: DealStatus[], newStatus: DealStatus) => (
  dealStatuses.includes(newStatus)
    ? dealStatuses.filter((status) => status !== newStatus)
    : [...dealStatuses, newStatus]
);

export const getInitialPayloadState = (pageFilters: IDealsPayload) => ({
  ...pageFilters,
    filters: {
  ...pageFilters.filters,
      // empty array means all statuses, but initially we need to show all selected
      includedStatusGroups: Object.values(DealStatus),
  },
    perPage: 10,
  }
);
